import { LanguageEnum } from '~/LocalizedStrings';
import useLanguage from './useLanguage';

export const UrlPath = {
  Home: '/',
  Application: '/application',
  FileAnApplication: '/application/file',
  FileThankYou: '/application/ty',
  MyApplication: '/application/my',
  Payment: '/application/:tmId/payment',
  IP: '/ip',
  GlobalStatus: '/ip/global',
  Watch: '/ip/watch',
  TrademarkManagement: '/ip/trademarks',
  Profile: '/profile',
  Verify: '/signup/verify',
  Auth: '/auth/:token',
} as const;

const getUrlPathWithAllLanguages = (path: string) =>
  Object.values(LanguageEnum).map((language) => `${language !== LanguageEnum.English ? `/${language}` : ''}${path}`);

export const UrlPathsWithAllLanguages = Object.entries(UrlPath).reduce(
  (obj, [key, value]) => ({
    ...obj,
    [key]: getUrlPathWithAllLanguages(value),
  }),
  {} as Record<keyof typeof UrlPath, string[]>
);

const useRouteNames = (languageProps?: string) => {
  const { language: LanguageFromContext } = useLanguage();

  const language = languageProps || LanguageFromContext;

  const getUrlWithLanguage = (url: string): string => {
    if (!language || language === 'en') {
      return url;
    }

    return `/${language}${url}`;
  };

  return Object.entries(UrlPath).reduce(
    (obj, [key, value]) => ({
      ...obj,
      [key]: getUrlWithLanguage(value),
    }),
    {} as Record<keyof typeof UrlPath, string>
  );
};

export default useRouteNames;
